"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeight = exports.getWidth = void 0;
const iframeDimensions = {
    width: {
        default: '100%',
        fixed: '328px'
    },
    height: {
        default: '44px',
        fixed: '44px'
    }
};
const getWidth = (size) => {
    let width;
    switch (size) {
        case 'default':
        case void 0:
            width = iframeDimensions.width.default;
            break;
        case 'fixed':
            width = iframeDimensions.width.fixed;
            break;
        default:
            width = '100%';
    }
    return width;
};
exports.getWidth = getWidth;
const getHeight = (size) => {
    let height;
    switch (size) {
        case 'default':
        case void 0:
            height = iframeDimensions.height.default;
            break;
        case 'fixed':
            height = iframeDimensions.height.fixed;
            break;
        default:
            height = '44px';
    }
    return height;
};
exports.getHeight = getHeight;
//# sourceMappingURL=getDimensions.js.map